import { OwnerGuideEntry } from "../../../../components/ownerOnboarding/entry";
import { useDispatch, useSelector } from "react-redux";
import { updateFloatPanel } from "../../../../reducers/userConfigSlice";
import { Edition as ProductEdition } from "../products/edition";
import { ProductMonitoringFields } from "../../../../components/productMonitoring";
//Components
import { InfoBlock } from "../../../../components/infoBlock";
import { LineChartComponent } from "../../../../components/charts/lineChart";
import { LuShoppingBag as TbCoinEuro, LuCircleDollarSign as LiaShoppingBasketSolid, LuPackage as BsPeople } from "react-icons/lu";
import { LuReceipt as FiShoppingCart } from "react-icons/lu";
import { FiBarChart2 } from "react-icons/fi";
import { FaSquare } from "react-icons/fa";
//Styles
import "./style.css";
import "./../../body/style.css";
import { Datatable, NoImage } from "@delibrandev/utils";
import { getIncompleteProducts } from "../../../../api/products";
import { useEffect, useState, useRef } from "react";
import { getStatistics } from "../../../../api/dashboard";

const formatMoney = (value) => {
  if (value == null || value === "") return "—";
  const amount = Number(value);
  return Number.isFinite(amount)
    ? new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: "EUR",
      }).format(amount)
    : "—";
};

export const Dashboard = () => {
  const dispatch = useDispatch();
  const panelVisible = useSelector(
    (state) => state.aplicationConfig.userConfig.floatPanel.visible,
  );
  const openProduct = (row) =>
    dispatch(
      updateFloatPanel({
        visible: true,
        queryId: row.productId,
        isEmpty: false,
        data: row,
      }),
    );
  // =========== Datatable Configuration ============

  const sections = [
    {
      text: "Revisión de productos",
      callback: () => null,
      actions: ["search"],
      actionsWithSelect: [],
    },
  ];
  const customHeaders = {
    images: "Imagen",
    reference: "Referencia",
    name: "Nombre",
    missingFields: "Datos por revisar",
    actions: "Acciones",
  };
  const customHeadersStyle = {
    missingFields: { width: "400" },
  };

  const customData = {
    actions: (_, row) => (
      <button
        type="button"
        className="monitoringResolve"
        onClick={() => openProduct(row)}
      >
        Resolver
      </button>
    ),
    images: (data) =>
      data[0] ? (
        <img
          src={data[0]}
          alt="product"
          width="60px"
          style={{ borderRadius: "10px" }}
        />
      ) : (
        <div style={{ height: "60px", width: "100px", margin: "auto" }}>
          <NoImage />
        </div>
      ),
    reference: (data) => <b>{data}</b>,

    missingFields: (data) => <ProductMonitoringFields fields={data} />,
  };
  // ================================================

  const [dataMonitoring, setDataMonitoring] = useState([]);
  const [dataStatistics, setDataStatistics] = useState({});
  const [statisticsStatus, setStatisticsStatus] = useState("loading");
  const [monitoringStatus, setMonitoringStatus] = useState("loading");
  const pending = useRef(false);
  const getQuery = async () => {
    if (pending.current) return;
    pending.current = true;
    setStatisticsStatus("loading");
    setMonitoringStatus("loading");
    await Promise.all([
      (async () => {
        try {
          const response = await getStatistics();
          if (
            !response ||
            response.error ||
            !response.data ||
            typeof response.data !== "object"
          )
            throw Error();
          setDataStatistics(response.data);
          setStatisticsStatus("ready");
        } catch {
          setDataStatistics({});
          setStatisticsStatus("error");
        }
      })(),
      (async () => {
        try {
          const response = await getIncompleteProducts({});
          if (!response || response.error || !Array.isArray(response.data))
            throw Error();
          setDataMonitoring(response.data);
          setMonitoringStatus("ready");
        } catch {
          setDataMonitoring([]);
          setMonitoringStatus("error");
        }
      })(),
    ]);
    pending.current = false;
  };

  useEffect(() => {
    if (!panelVisible) getQuery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panelVisible]);

  const infoBlocks = [
    {
      icon: <TbCoinEuro />,
      title: "Pedidos",
      value:
        dataStatistics?.orderCount == null
          ? "—"
          : String(dataStatistics.orderCount),
    },
    {
      icon: <LiaShoppingBasketSolid />,
      title: "Ventas totales",
      value: formatMoney(dataStatistics?.totalSales),
    },
    {
      icon: <FiShoppingCart />,
      title: "Valor medio del carrito",
      value: formatMoney(dataStatistics?.averageCartValue),
    },
    {
      icon: <BsPeople />,
      title: "Productos vendidos",
      value:
        dataStatistics?.totalProductsSold == null
          ? "—"
          : String(dataStatistics.totalProductsSold),
    },
  ];

  return (
    <>
      <div className="topContainer">
        <div className="pageHeading">
          <h1 className="bodyTitle">Inicio</h1>
          <p>La actividad de tu negocio, de un vistazo.</p>
        </div>
        <div className="actionsDashboard">
          {/*<Button text={"Exportar"} icon={<PiExport />} />
          <Select
            values={[
              { id: 0, name: "Todos los canales" },
              { id: 1, name: "Teléfono" },
              { id: 2, name: "Tienda física" },
              { id: 3, name: "WhatsApp" },
              { id: 4, name: "Correo electrónico" },
            ]}
          />
          <Select
            values={[
              { id: 0, name: "Últimos 30 días" },
              { id: 1, name: "Últimos 90 días" },
              { id: 2, name: "Últimos 120 días" },
              { id: 3, name: "Último año" },
            ]}
          />*/}
        </div>
      </div>

      <OwnerGuideEntry />
      <div className="infoBlocksContainerDashboard">
        {statisticsStatus === "loading" ? (
          <p role="status">Cargando estadísticas…</p>
        ) : statisticsStatus === "error" ? (
          <div role="alert">
            No se pudieron cargar las estadísticas.{" "}
            <button type="button" onClick={getQuery}>
              Reintentar
            </button>
          </div>
        ) : (
          infoBlocks?.map((block, idx) => (
            <InfoBlock
              key={block.title + idx}
              icon={block.icon}
              title={block.title}
              value={block.value}
              graph={false}
            />
          ))
        )}
      </div>

      <div className="chartContainer">
        <div className="adminPanel">
          <div className="adminCardHeader">
            <h2>Estadísticas</h2>
            <p>Resumen de ventas y productos vendidos.</p>
          </div>
          {statisticsStatus === "ready" && (
            <div className="dashboardStaticsResume">
              <div className="dashboardStaticsResumeBlock">
                <div className="dashboardStaticsResumeLabel">
                  <FaSquare color={"darkblue"} /> Ventas totales
                </div>
                <div className="dashboardStaticsResumeValue">
                  {formatMoney(dataStatistics?.totalSales)}
                </div>
              </div>
              <div className="dashboardStaticsResumeBlock">
                <div className="dashboardStaticsResumeLabel">
                  <FaSquare color={"lightblue"} /> Productos vendidos
                </div>
                <div className="dashboardStaticsResumeValue">
                  {dataStatistics?.totalProductsSold == null
                    ? "—"
                    : String(dataStatistics.totalProductsSold)}
                </div>
              </div>
            </div>
          )}
          <div className="adminChartEmpty">
            <FiBarChart2 aria-hidden="true" />
            <LineChartComponent yAxis={false} />
            <small>
              El gráfico aparecerá cuando haya datos diarios disponibles.
            </small>
          </div>
        </div>
      </div>

      <section className="adminMonitoring">
        <div className="adminCardHeader">
          <h2>Revisión de productos</h2>
          <p className="product-monitoring-help">
            Revisa el nombre y el precio. El lote solo se comprueba si su
            gestión está activada. Los demás datos opcionales no generan avisos.
          </p>
        </div>
        {monitoringStatus === "loading" ? (
          <p role="status">Cargando monitoreo…</p>
        ) : monitoringStatus === "error" ? (
          <div role="alert">
            No se pudo cargar el monitoreo.{" "}
            <button type="button" onClick={getQuery}>
              Reintentar
            </button>
          </div>
        ) : dataMonitoring.length === 0 ? (
          <p className="product-monitoring-empty" role="status">
            No hay datos de productos pendientes de revisión.
          </p>
        ) : (
          <Datatable
            data={dataMonitoring}
            customHeaders={customHeaders}
            customHeadersStyle={customHeadersStyle}
            customData={customData}
            sections={sections}
            rowCallback={openProduct}
            deleteCallback={() => null}
            identificator={"dashboard-monitoring"}
          />
        )}
      </section>

      <ProductEdition />
    </>
  );
};
